const PROD_API_BASE_URL = "https://api.hardlobby.site";
const DEV_API_BASE_URL = "http://127.0.0.1:8000";
const IS_PRODUCTION = true; // Set to true for production mode
const API_BASE_URL = IS_PRODUCTION ? PROD_API_BASE_URL : DEV_API_BASE_URL;
const DEBUG = false;

// IMPORTANT: This MUST match EXACTLY what's configured in Google Cloud Console
// Including protocol (http vs https), port number, and path
const GOOGLE_REDIRECT_URI = IS_PRODUCTION
  ? "https://hardlobby.site/google/callback"
  : "http://127.0.0.1:3000/google/callback"; // Using port 3000 which is the actual running port

const GOOGLE_CLIENT_ID = "740250279344-dv7i3ngo1gcgnael6p158bjj7h6r348o.apps.googleusercontent.com";
const GOOGLE_CLIENT_SECRET = "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";

// Get VAPID key from environment variables
const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

// Correctly export the Firebase configuration
export { GOOGLE_CLIENT_ID, GOOGLE_REDIRECT_URI, GOOGLE_CLIENT_SECRET };
export { PROD_API_BASE_URL, DEV_API_BASE_URL, IS_PRODUCTION, API_BASE_URL, DEBUG };
export { FIREBASE_VAPID_KEY }; // Only export VAPID key

